import { each, isEqual } from 'lodash';
import * as React from 'react';
import { DEFAULT_SELECTED_WEEK } from '../../stores/jotai/base';
import isValidCanvasActivity from '../../util/isValidCanvasActivity';
import MaterialCanvas from './material-canvas';
import { Activity } from '../../stores/jotai/activities/activities';

interface Props {
    groupID?: string;
    layout?: any;
    orientation?: string;
    org: OrgState;
    user: User;
    team: TeamState;
    cohort?: CohortState;
    app: AppState;
    activityFeed?: Activity;
    canvas?: object;

    baseAtomBridge?: any;

    entries: { [key: string]: CanvasEntry }
    hypothesisLinkHandler?: (entryID: string, targetEntryID: string, removeLink: boolean) => void;
    hypothesisHoverHandler?: (linkedHypotheses: HypothesisLink[], isHovered: boolean) => void;
    relatedEntries?: string[];

    isPeriodOnCurrent: boolean;
    isReadOnlyManual: boolean;
    focusEntryID?: string;

    parentCategoryID?: string;

    handleCanvasChange: Function;
    chatID: string; // The user can specify a chatID in the URL to specify opening that chat on load

    isHidingStaleEntries: boolean;

    canvasTargetComment?: string;

    // ID of the group holding our comment context
    commentContextID: string;

    canvas_filter_showInvalidated: boolean;
    canvas_filter_showValidated: boolean;
    canvas_filter_showUnresolved: boolean;

    library?: any;
}

interface State {
    layout?: CanvasLayout;
    categoriesByName?: { [key: string]: CanvasCategory }

    /** sets which category has a placeholder entry (if any) */
    categoryWithPlaceholder?: string;
    placeholderSaving?: boolean;

    hoverMap: { [key: string]: boolean };

    canvas_filter_showInvalidated: boolean,
    canvas_filter_showValidated: boolean,
    canvas_filter_showUnresolved: boolean
}

// Check to see if any chat windows are open on the BMC
export function isAnyChatOpen(group: TeamState): boolean {
    if (!group) return false;

    if (group.commentHoverTarget === '') return false;
    if (group.commentHoverTarget === undefined) return false;

    return true;
}

interface CanvasEntries { [key: string]: CanvasEntry };

export default class Canvas extends React.Component<Props, State> {

    state = {
        canvas_filter_showInvalidated: true,
        canvas_filter_showValidated: true,
        canvas_filter_showUnresolved: true
    }

    static defaultProps = {
        orientation: 'canvas',
        layout: 'BusinessModel',
        anchor: 'all'
    }

    getValidActivityFeedLength = () => {
        const {
            activityFeed
        } = this.props;

        if (!activityFeed || !activityFeed?.length) return 0;

        let count = 0;

        each(activityFeed, feed => {
            const {
                name
            } = feed;

            if (isValidCanvasActivity(feed)) {
                count += 1;
            }
        });

        return count;
    }

    getIsInPeriodOrWeek = () => {
        const {
            canvas
        } = this.props;

        // When no week is selected it's in "period mode"
        //@ts-ignore
        if (canvas.selectedWeek === DEFAULT_SELECTED_WEEK) {
            return "period";
        }
        else {
            return "week";
        }
    }

    getSliderMax = () => {
        const {
            activityFeed
        } = this.props;

        if (!activityFeed) return 0;

        return this.getValidActivityFeedLength();
    }

    getCurrentWeek = () => {
        const {
            canvas
        } = this.props;

        return canvas.selectedWeek;
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (!isEqual(this.props, nextProps)) return true;
        if (!isEqual(this.state, nextState)) return true;

        return false;
    }

    render() {
        const {
            app,
            cohort,
            team,
            entries,
            org,
            user,
            layout,
        } = this.props;
        return <MaterialCanvas
            layout={layout}
            app={app}
            entries={entries}
            user={user}
            cohort={cohort}
            commentContextID={this.props.commentContextID}
            getIsInPeriodOrWeek={() => { return this.getIsInPeriodOrWeek(); }}
            getCurrentWeek={() => { return this.getCurrentWeek()}}
            org={org}
            team={team}
        />
    }
}
